export enum userCheckInStatus {
	CheckedIn = 'CheckedIn',
	CheckedOut = 'CheckedOut',
}
